// data-component="accordion" data-status="open"
// –– data-element="title"
// –– data-element="body"
import { switchDataSet } from './utils';
const accordionInit = () => {
    const accordions = document.querySelectorAll('[data-component="accordion"]');
    if (accordions) {
        accordions.forEach(item => accordion(item));
    }
    else {
        console.log('Accordions not found');
    }
};
const accordion = (item) => {
    const title = item.querySelector('[data-element="title"]');
    title && title.addEventListener('click', function (event) {
        const target = event.target;
        let status = target.closest('[data-component="accordion"]').dataset.status;
        if (status === 'close') {
            event.preventDefault();
            switchDataSet(item, 'open', 'close');
        }
    });
};
export default accordionInit;
